import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { camelToSentenceCase } from "../../helper/utils";

export default function TenderPartsTable({ id, rows }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target?.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const visibleRows = React.useMemo(() => {
    return rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);

  return (
    <>
      {rows && rows[0] ? (
        <TableContainer width={"100%"} component={Box}>
          <Table width={"100%"} size="small">
            <TableHead>
              <TableRow>
                {typeof rows[0] === "string" ? (
                  <TableCell>Item</TableCell>
                ) : (
                  Object.keys(rows[0])?.map((header) => (
                    <TableCell>{camelToSentenceCase(header)}</TableCell>
                  ))
                )}
              </TableRow>
            </TableHead>
            <TableBody style={{ maxHeight: 100 }}>
              {visibleRows.map((row) => (
                <TableRow>
                  {typeof rows[0] === "string" ? (
                    <TableCell>{row}</TableCell>
                  ) : (
                    Object.keys(row)?.map((header) => (
                      <TableCell>{row[header]}</TableCell>
                    ))
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <p id={id} style={{ textAlign: "center" }}>
          No Data Found
        </p>
      )}
      {rows && rows[0] && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          // style={{ backgroundColor: theme.palette.background.paper }}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
}
